"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DekoDirectDebitInfo = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("p", null, "Your monthly repayments will be collected by Direct Debit from your nominated bank or building society account, approximately 15-30 days after the retailer has fulfilled your order. The lender will contact you to confirm the exact date."),
        React.createElement("p", null, "This should be your personal bank account and you must be the sole holder and/or have authority to set up Direct Debit payments.")));
};
exports.default = DekoDirectDebitInfo;
